import React from "react";
import { Spinner, Empty } from "@/components/ui";
import { AlertTriangle } from "lucide-react";

// Consistent loading / error / empty wrapper for deliverable screens.
export default function DeliverableState({ loading, error, empty, isAr, children, height = "min-h-[50vh]" }) {
  if (loading)
    return (
      <div className={`grid place-items-center ${height}`}>
        <Spinner size={36} className="text-primary" />
      </div>
    );
  if (error)
    return <Empty icon={AlertTriangle} title={isAr ? "تعذّر التحميل" : "Failed to load"} hint={error} />;
  if (empty)
    return <Empty title={isAr ? "لا توجد بيانات" : "No data"} />;
  return children;
}
